import React from 'react';
import { Header, Grid } from 'semantic-ui-react';
import axios from 'axios';
import Notifications from '../Notifications/Notifications';
import StudentServiceHomeStatistic from '../StudentService/StudentServiceHomeStatistic';
// import StudentServiceHomeStatistic from '../StudentService/StudentServiceHomeStatistic';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;


export default class PropertyHome extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        // const FadeIn = styled.div`animation: 1s ${keyframes`${zoomIn}`}`;
        return (
            <div >
                <Header as="h1">Početna</Header>
                {/* <Grid columns={2} centered stackable> */}
                {/* <Grid.Column width={16} stretched > */}
                {/*    <FadeIn> <Notifications /></FadeIn> */}
                {/* </Grid.Column> */}
                Početna za imovinu...


                {/* </Grid> */}
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/views/Home/PropertyHome.js